import Smooth from 'smoothscroll'
export default ProductDetail

function ProductDetail() {
  const types = [...document.querySelectorAll('.js-product-detail-type')]
  const mockedRadios = [...document.querySelectorAll('.c-product-detail-option__mocked-radio')]
  const checkboxLabels = [...document.querySelectorAll('.c-check-checkbox__label')]
  const toFormNotice = document.querySelector('.js-to-form')
  const options = [...document.querySelectorAll('.js-product-detail-options')]
  const typesInput = document.querySelector('input[name="product-type"]')
  const optionsInput = document.querySelector('input[name="product-options"]')
  const selected = []
  if (types && typesInput) {
    types.forEach(type => {
      type.addEventListener('change', function () {
        const notice = document.querySelector('.js-product-types-notion')
        notice.style.display = 'none'
        typesInput.value = this.id
        removeClasses(mockedRadios, 'c-product-detail-option__mocked-radio--blink')
        setTimeout(() => {
          Smooth(document.getElementById('product-options'), 1000)
        }, 250)
      })
    })
  }

  if (options && optionsInput) {
    options.forEach(option => {
      if (option.checked) {
        selected.push(option.id)
      }
      option.addEventListener('change', function () {
        removeClasses(checkboxLabels, 'c-check-checkbox__label--blink')
        toFormNotice.style.opacity = 1;
        if (this.checked) {
          selected.push(this.id)
        } else {
          selected.splice(selected.indexOf(this.id), 1)
        }
        updateInput(selected, optionsInput)
      })
    })
  }
}

function removeClasses(items, className) {
  items.forEach(item => {
    item.classList.remove(className)
  })
}

function updateInput(selected, optionsInput) {
  optionsInput.value = selected.join(', ')
}


// WEBPACK FOOTER //
// ./src/js/modules/ProductDetail.js